import React from 'react';
import { Translate } from 'react-translate.ts';

export function NotFound() {
    return (
        <div>
            <h1>404</h1>
            <h2>
                <Translate namespace="common">fe.error.not-found</Translate>
            </h2>
        </div>
    );
}
